import type { PettyWorkItem } from "../types/petty-work.types";

export function pettyWorkLineQuantity(line: PettyWorkItem): number {
  const q: unknown = line.quantity ?? line.qty;
  if (typeof q === "number" && Number.isFinite(q)) return q;
  if (typeof q === "string" && q.trim() !== "") {
    const n = Number(q);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

export function pettyWorkLineSummary(items: PettyWorkItem[] | null | undefined): string {
  const rows = items ?? [];
  if (!rows.length) return "—";
  const parts = rows.slice(0, 3).map((ln) => {
    const label =
      ln.product?.name?.trim() ||
      ln.description?.trim() ||
      (ln.productId ? `Product #${ln.productId}` : "Line");
    const q = pettyWorkLineQuantity(ln);
    return `${label} (${q})`;
  });
  const more = rows.length > 3 ? ` +${rows.length - 3} more` : "";
  return `${parts.join(" · ")}${more}`;
}
